module.exports = __webpack_public_path__ + "static/media/Modelo.02033a4e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Modelo.jpg
// module id = 518
// module chunks = 0